module.exports = __webpack_public_path__ + "assets/media/information_tongue.bf357d84.mp4";